/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.57"
        height="91.94"
        viewBox="0 0 95.57 91.94"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M72.87.01a8.23 8.23 0 0 1 7.72 6.16 6.83 6.83 0 0 1 .25 1.61v71.91a1.27 1.27 0 0 1-1.28 1.23 1.24 1.24 0 0 1-1.21-1.1V8.13a4.61 4.61 0 0 0-.16-1.27 5.75 5.75 0 0 0-5.09-4.35H9.58A1.25 1.25 0 0 1 9.5.02h63.37Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M86.75 91.94H24.59a8.12 8.12 0 0 1-8.09-7.88V47.91H1.25a1.24 1.24 0 0 1-1.24-1.13V9.59a9.28 9.28 0 0 1 9-9.57h.5a9.06 9.06 0 0 1 9.48 8.62v75.19a5.61 5.61 0 0 0 5.4 5.61h2c3.46 0 5.26-1.64 6-4.56a13.3 13.3 0 0 0 .27-4.45v-.53a1.27 1.27 0 0 1 1-1.45h60.59a1.26 1.26 0 0 1 1.23 1v.7a15.79 15.79 0 0 1-.33 5.31c-1 3.87-3.6 6.33-8.1 6.44Zm6.3-11H35.2v.1a15.33 15.33 0 0 1-.29 4l-.1.44a9.1 9.1 0 0 1-2 3.87l-.07.08h54c3.36 0 5.16-1.55 5.93-4.31l.07-.25a13 13 0 0 0 .32-3.57ZM9.74 2.51H9.5a6.8 6.8 0 0 0-7 6.58v36.32h14V9.59c0-4.37-2.9-7.02-6.76-7.08Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M31.61 12.07v2.14l-.34.07-.32.08a5.16 5.16 0 0 0-3.87 3.17 6.4 6.4 0 0 0-.45 2.93 5 5 0 0 0 2.69 4.28 18.8 18.8 0 0 0 2.25 1c.94.4 1.9.76 2.84 1.16a1.74 1.74 0 0 1 1.1 1.84 1.86 1.86 0 0 1-1.5 1.88 4.77 4.77 0 0 1-1.19.13 3 3 0 0 1-3-2.21c-.09-.26-.15-.53-.23-.82l-3.59.92a7.3 7.3 0 0 0 1.73 3.56 6 6 0 0 0 3.94 1.81v2.78h2.28v-2.75c.47-.1.92-.17 1.36-.28a5.32 5.32 0 0 0 3.78-3.07 6.22 6.22 0 0 0 .38-3.74 5 5 0 0 0-2.52-3.59 30.7 30.7 0 0 0-3.43-1.5c-.71-.28-1.39-.6-2.07-.93a1.48 1.48 0 0 1-.77-.94 2.08 2.08 0 0 1 1.37-2.61h.09a2.46 2.46 0 0 1 2.4.63 4.46 4.46 0 0 1 1 1.47c.08.18.15.36.23.55l3.22-1.33a6.74 6.74 0 0 0-1.18-2.42 5.67 5.67 0 0 0-3.91-2V12.1Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M70.15 15.28a1 1 0 0 1 1.06.94 1 1 0 0 1-.94 1.06H45.76a1 1 0 0 1-1.06-.94 1 1 0 0 1 .94-1.06ZM64.86 23.1a1 1 0 0 1 1.06.94 1 1 0 0 1-.94 1.06H45.76a1 1 0 0 1-1.06-.94 1 1 0 0 1 .94-1.06ZM61.14 30.92a1.002 1.002 0 0 1 .11 2H45.76a1 1 0 0 1-1.06-.94 1 1 0 0 1 .94-1.06ZM70.36 66.51a1 1 0 0 1 1.06.94 1 1 0 0 1-.94 1.06H28.01a1 1 0 0 1-1.06-.94 1 1 0 0 1 .94-1.06Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M32.88 53.91a1 1 0 0 1 1 .88v12.72a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V54.91a1 1 0 0 1 1-1ZM41.03 45.41a1 1 0 0 1 1 .88v19.73a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V46.41a1 1 0 0 1 1-1ZM49.18 51.9a1 1 0 0 1 1 .88v13.24a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V52.9a1 1 0 0 1 1-1ZM57.33 55.22a1 1 0 0 1 1 .88v9.92a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94v-9.92a1 1 0 0 1 1-1ZM65.5 42.79a1 1 0 0 1 1 .88v22.35a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V43.79a1 1 0 0 1 1-1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PaperWithDollarSignAndBarChartIcon';

export default Icon;
